import React from "react";
import { color as palette } from "@/constants/palette";

function Flag() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      // className="absolute right-0"
      width="19"
      height="23"
      viewBox="0 0 19 23"
      fill="none"
    >
      <rect x="1.11328" y="11" width="4.96957" height="12" fill={palette.lineStrong} />
      <path
        d="M0.117188 1C0.117188 0.447715 0.564903 0 1.11719 0H17.0498C17.8648 0 18.3375 0.922661 17.8614 1.58416L14.8879 5.71551C14.6252 6.08053 14.6385 6.57603 14.9204 6.92646L17.693 10.3732C18.2193 11.0275 17.7535 12 16.9138 12H1.11719C0.564902 12 0.117188 11.5523 0.117188 11V1Z"
        fill={palette.accent}
      />
    </svg>
  );
}

export default Flag;
